<template>
    <div v-if="pagesCount > 1" class="flex justify-end">
        <NuxtLink
            :to="`${$route.path}?page=${page === 1 ? 1 : page - 1}`"
            class="nav-button border-transparent"
            :class="{
                'pointer-events-none opacity-40': page === 1,
                'border-black/30 desktop:hover:border-black': lightTheme,
                'border-white/60 desktop:hover:border-white': !lightTheme,
            }"
            @click.native="scrollToTop"
        >
            <i class="pi pi-chevron-left"></i>
        </NuxtLink>

        <span v-for="(pageNumber, i) in pageNavButtonsToDisplay" :key="`${i}-${pageNumber}`">
            <NuxtLink
                v-if="!isNaN(pageNumber)"
                :to="`${$route.path}?page=${pageNumber}`"
                class="nav-button"
                :class="{
                    'pointer-events-none': page === pageNumber,
                    'border-black/30 desktop:hover:border-black': lightTheme,
                    'border-white/60 desktop:hover:border-white': !lightTheme,
                    'border-white bg-black text-white ': lightTheme && page === pageNumber,
                    'border-black bg-white text-black': !lightTheme && page === pageNumber,
                }"
                style="transition-timing-function: ease-in"
                @click.native="scrollToTop"
            >
                {{ pageNumber }}
            </NuxtLink>
            <span v-else class="h-8 mx-1 flex items-end">...</span>
        </span>

        <NuxtLink
            :to="`${$route.path}?page=${page === pagesCount ? page : page + 1}`"
            class="nav-button border-transparent"
            :class="{
                'pointer-events-none opacity-40': page === pagesCount,
                'border-black/30 desktop:hover:border-black': lightTheme,
                'border-white/60 desktop:hover:border-white': !lightTheme,
            }"
            @click.native="scrollToTop"
        >
            <i class="pi pi-chevron-right"></i>
        </NuxtLink>
    </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        pagesCount: {
            type: Number,
            required: true,
        },
        page: {
            type: Number,
            required: true,
        },
        lightTheme: {
            type: Boolean,
            required: false,
            default: false,
        },
        scrollTarget: {
            type: String,
            required: false,
            default: null,
        },
    },
    computed: {
        pageNavButtonsToDisplay() {
            if (this.pagesCount < 6) {
                return this.pagesCount;
            } else {
                return [...Array(this.pagesCount).keys()].reduce((acc, curr, i, arr) => {
                    // p is the active page, starting from 0
                    const p = this.page - 1;

                    if (
                        [0, arr.length - 1, p, p - 1, p + 1].includes(curr) ||
                        (p < 4 && [2, 3].includes(curr)) ||
                        (p > arr.length - 5 && [arr.length - 4, arr.length - 3].includes(curr))
                    ) {
                        acc.push(curr + 1);
                    } else if (!isNaN(acc[acc.length - 1])) {
                        acc.push('...');
                    }
                    return acc;
                }, []);
            }
        },
    },
    methods: {
        scrollToTop() {
            if (document.querySelector(this.scrollTarget)) {
                this.$scrollToElement(this.scrollTarget, 20, 'auto');
            }
        },
    },
};
</script>

<style scoped>
.nav-button {
    @apply w-8  h-8 font-bold border rounded-full mx-1 inline-flex items-center justify-center transition-all;
    transition-duration: 0.15s;
}
</style>
